/** A nonempty staff-authored string explicitly opts into the new welcome shell.
 */
export const getWelcomeScreenHtml = (value) => (typeof value === 'string' ? value.trim() : '');
//# sourceMappingURL=welcomeScreenConfig.js.map